<template>
  <div class="d-flex align-items-center" v-show="loadingCompleted">
    <span class="image-panel image-panel-n2 bg-none"><img :src="iconSource" :alt="typeName" class="w-100"></span>
    <span class="font-size-sm text-mcf-color">{{ haveUserPointWording }}</span>
    <div class="font-size-lg text-customize d-inline-block font-weight-normal mb-0 mx-1">{{ totalPoint }}</div>
    <span class="font-size-sm text-mcf-color">{{ pointUnit }}</span>
  </div>
</template>

<script>
import pageSettingGetter from '@/utils/pageSettingGetter';

export default {
  data() {
    return {
      // 資料是否完成載入
      loadingCompleted: false,
      // 會籍icon來源
      iconSource: '',
      // 會籍名稱
      typeName: '',
      // 會員積點總和
      totalPoint: 0,
      // 點數單位
      pointUnit: '',
      // 可使用點數文案
      haveUserPointWording: '',
    };
  },
  created() {
    const vm = this;
    // 取得頁面設定資料
    const getPageSetting = vm.$store.dispatch('getPageSetting', 'RedeemItem');
    getPageSetting.then((setting) => {
      vm.pointUnit = pageSettingGetter.getFunctionWording(setting, 'UserPointUnit');
      vm.haveUserPointWording = pageSettingGetter.getFunctionWording(setting, 'HaveUserPointWording');
    });
    // 取得會籍資料
    const getMemberType = vm.$store.dispatch('getMemberType');
    getMemberType.then((memberType) => {
      vm.iconSource = memberType.iconPic;
      vm.typeName = memberType.currentLevel;
    });
    // 取得會員積點
    const getMemberBonus = vm.$store.dispatch('getMemberBonus');
    getMemberBonus.then((memberBonus) => {
      vm.totalPoint = memberBonus.pointSum;
    });
    Promise.all([getPageSetting, getMemberType, getMemberBonus])
      .then(() => { vm.loadingCompleted = true; });
  },
};
</script>
